export default __webpack_public_path__ + "static/media/toplights1.2afb6385.PNG";